import React from 'react';
import BlazeDropdown, { BlazeDropdownItem } from 'components/ui/dropdown/BlazeDropdown/BlazeInputDropdown';
import { MockService, MockServiceUpgradeOptions } from 'types/rest/mockServiceTypes';

export const defaultStatus: BlazeDropdownItem = {
  id: 'UPGRADE',
  name: 'Upgrade',
};

export const defaultStatusLoading: BlazeDropdownItem = {
  id: 'UPGRADE',
  name: 'Upgrading',
};

const mockServicesUpgradeItems: BlazeDropdownItem[] = [
  {
    id: 'MOCK',
    name: 'This Virtual Service',
  },
  {
    id: 'ALLMOCKS',
    name: 'All Virtual Services in This Location',
  },
];

type MockServiceUpgradeProps = {
  /** Currently selected status*/
  status?: MockServiceUpgradeOptions | null;
  /** On Change handler */
  changeStatusHandler: (status: MockServiceUpgradeOptions | null) => void;
  isUpgrading?: boolean;
  mockService: MockService | undefined;
};

const MockServiceUpgradeDropdown = (props: MockServiceUpgradeProps) => {
  const selectStatusHandler = (mockServicesUpgradeItem: BlazeDropdownItem) => {
    if (mockServicesUpgradeItem.id !== 'UPGRADE') {
      props.changeStatusHandler(mockServicesUpgradeItem.id as any);
    } else {
      props.changeStatusHandler(null);
    }
  };

  /** Translates id of selected status to BlazeDropdownItem */
  const getSelectedItem = () => {
    if (props.status === null) {
      return defaultStatus;
    }
    const status = mockServicesUpgradeItems.find(item => item.id === props.status);
    return status ? status : defaultStatus;
  };

  return (
    <>
      <div className="d-inline-block" style={{ float: 'right' }}>
        <BlazeDropdown
          id={'qa-mock-service-status-picker'}
          showGroups={false}
          isSearchable={false}
          minDropdownMenuWidth={290}
          maxDropdownHeight={250}
          items={mockServicesUpgradeItems}
          selected={getSelectedItem()}
          onClick={selectStatusHandler}
          isDefaultOptionSelectable={false}
          defaultOption={props.isUpgrading ? defaultStatusLoading : defaultStatus}
          isHighlighted={!props.isUpgrading}
          disabled={props.isUpgrading}
          isLoading={false}
          isLoadingButton={props.isUpgrading ? true : false}
          isTitleHidden={true}
        />
      </div>
    </>
  );
};

export default MockServiceUpgradeDropdown;
